export const ROUTES = {
  LOGIN: "/login",
  VERIFY: "/auth/verify",
  /** Pairing app root. The sidebar and mobile home link to PAIR. */
  PAIRING: "/pair",
  PAIR_LOGIN: "/pair/login",
  ENROLL: "/enroll",
  DEMO_KIT_ONBOARDING: "/app/demo-kit-onboarding",
  HOME: "/",
  ASSETS: "/app/assets",
  TRIPS: "/app/trips",
  ALERTS: "/app/alerts",
  SUPPORT: "/app/support",
  SYSTEM: "/app/system",
  STANDBY_SENSORS: "/app/system/standbySensors",
  READERS: "/app/system/readers",
  REPORTS: "/app/reports",
  TOWERS: "/app/towers",
  WIFI_PROVISIONING: "/app/system/wifiProvisioning",
  /** Admin-only; not linked from sidebar or mobile nav — open via URL only. */
  SENSOR_LOCATION_DASHBOARD: "/app/admin/sensor-location-dashboard",
};
